import apiService from '@/services/apiService';

const actions = {
  getReserveLogWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/non-universals/reservation-logs/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getReserveLogDetailWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/non-universals/reservation-details/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteReservationLog({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`promo/voucher/non-universals/reservation-logs/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  resetReservationLog({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.post(`promo/voucher/non-universals/reservations/restart`,payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  getUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`promo/voucher/universal/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/universal', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`promo/voucher/universal/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCampaignWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/campaign/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getNonUniversalVouchers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/non-universal/find-all', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  reserveNonUniversalVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/non-universal/reserve', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;